import { BaseDto } from '../../base/dtos/base.dto';
import { FileDto } from '../../files/dtos/file.dto';
import { AreaTypeEnum } from '../enums/area-type.enum';

import { CountryDto } from './country.dto';

/**
 * Area DTO
 */
export class AreaDto extends BaseDto {
	/**
	 * Area UUID
	 */
	uuid!: string;

	/**
	 * Country ID this area belongs to
	 */
	countryId!: number;

	/**
	 * Country this area belongs to
	 */
	country!: CountryDto;

	/**
	 * Parent area ID if this area is a sub-area (e.g., a city within a state).
	 */
	parentId?: number;

	/**
	 * Parent area if this area is a sub-area (e.g., a city within a state).
	 */
	parent?: AreaDto;

	/**
	 * Area name
	 */
	name!: string;

	/**
	 * Area type
	 */
	type!: AreaTypeEnum;

	/**
	 * Flag indicating whether this area is in use
	 */
	isVisible!: boolean;

	/**
	 * External reference for the area
	 */
	externalReference?: string;

	/**
	 * Metadata associated with the area
	 */
	metadata?: Record<string, any>;

	/**
	 * Center of the area represented as a GeoJSON Point
	 */
	center!: string;

	/**
	 * Polygon of the area represented as a GeoJSON Polygon
	 */
	polygon!: string;

	/**
	 * Files associated with the area
	 */
	files?: FileDto[];
}
